import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

const ScoreInadimplenciaChartTurmaOcupacaoInstituicao = ({ color, title, labelColor, data }) => {
  const [drawerWidth, setDrawerWidth] = useState('Saídas');

  const months = data?.map((item) => item.ano);
  const receivedValues = data?.map((item) => item.valor);
  const delinquentPercentages = data?.map((item) => item.valor_secundario);
  
  const series = [
    {
      data: receivedValues,
      type: 'bar',
      stack: 'a',
      name: 'Entradas',
      itemStyle: {
        color: color,
      },
      label: {
        show: true,
        position: 'top',
        formatter: (params) => formatLargeNumber(params.value), 
        color: '#000', 
      },
    },
    {
      data: delinquentPercentages,
      type: 'bar',
      stack: 'b',
      name: 'Saídas',
      itemStyle: {
        color: '#E04A4C',
      },
      label: {
        show: true,
        position: 'top',
        formatter: (params) => formatLargeNumber(params.value), 
        color: '#000',
      },
    },
  ];

  const option = {
    title: {
      text: title,
      textStyle: {
        fontSize: '12px',
      }
    },
    legend: {
      data: [drawerWidth, 'Entradas'],
      right: '0',
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        let tooltipContent = `<div>Mês: ${params[0].name}</div>`; 
        params.forEach(param => {
          if (param.seriesName === 'Entradas') {
            tooltipContent += `<div>Entradas: ${formatLargeNumber(param.value)}</div>`;
          } else if (param.seriesName === 'Saídas') {
            tooltipContent += `<div>Saídas: ${formatLargeNumber(param.value)}</div>`;
          }
        });
        return tooltipContent;
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '',
        position: 'left',
      },
      {
        type: 'value',
        name: '',
        position: 'right',
        axisLabel: {
          formatter: '',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', padding: '20px 10px 0 10px' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ScoreInadimplenciaChartTurmaOcupacaoInstituicao;
